import createClient from 'openapi-fetch';
import type { paths } from '@trackercop/contracts';

// Single source of truth for wire calls. Every fetch is typed against the
// OpenAPI spec in @trackercop/contracts/openapi.yaml — never write a raw
// fetch() inside a component or a hook.
//
// `credentials: 'include'` is required because Cloudflare Access attaches its
// session cookie (`CF_Authorization`) to same-site requests; the Worker's
// JWT verifier reads it from the Cookie header. The CORS middleware in the
// Worker sets `Access-Control-Allow-Credentials: true` for this to work.
//
// baseUrl is `/api` so the relative paths defined in the OpenAPI spec (/me,
// /sites, /crawls, ...) map to the Worker's /api-prefixed routes. The path
// prefix is a deployment detail: Cloudflare Pages owns / on the env's
// hostname (SPA), the Worker's route patterns claim /api/* (and /healthz).
// Same-origin means no CORS, one Access app, one cookie.
export const apiClient = createClient<paths>({
  baseUrl: '/api',
  credentials: 'include',
});

export type ApiClient = typeof apiClient;
